import React from 'react';

import { Empty, Button } from 'antd';

const EmptyList = ({
  openModalForCreateNewList,
  titleBtn,
  modalType,
  description = null,
  edit = false,
}) => (
  <div className="full_empty">
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description}>
      {edit ? (
        <Button
          type="primary"
          onClick={() => openModalForCreateNewList(modalType)}
        >
          <span>{titleBtn}</span>
        </Button>
      ) : null}
    </Empty>
  </div>
);

export default EmptyList;
